export default __webpack_public_path__ + "static/media/ES Branding & Creative Consultancy.24959856.jpg";